module.exports = __webpack_public_path__ + "static/img/20250320001.3990441.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/20250320001.jpg
// module id = S2QQ
// module chunks = 0